import {Injectable} from '@angular/core';
import {Platform} from '@ionic/angular';

@Injectable({
	providedIn: 'root'
})
export class PlatformService {

	public isDesktop: boolean;
	public isTablet: boolean;

	constructor(private platform: Platform) {
		this.platform.ready().then(() => {
			this.isDesktop = (this.platform.is('desktop') && !this.platform.is('phablet')) || (this.platform.is('tablet') && this.platform.is('mobileweb')) || (this.platform.is('mobile') && this.platform.is('mobileweb'));
			this.isTablet = !this.isDesktop && this.platform.is('tablet');
		});
	}
}
